import { Action } from '@ngrx/store';
import { TcsEntityRecord } from 'src/store/generated/client-sync.generated';

export const FETCH_ENTITIES = '[Entities] FETCH_ENTITIES';
export const ENTITIES_RECEIVED = '[Entities] ENTITIES_RECEIVED';
export const ENTITIES_REMOVED = '[Entities] ENTITIES_REMOVED';
export const REQUEST_ENTITIES = '[Entities] ENTITIES_FETCHED';
export const RESET_ENTITIES = '[Entities] RESET_ENTITIES';

export class FetchEntities implements Action {
  public readonly type = FETCH_ENTITIES;
  constructor(public readonly fetched: { type: string; id: string }[]) {}
}

export type EntityChangeType = EntityUpdateChangeType | 'Removed';

export type EntityUpdateChangeType = 'Fetched' | 'Added' | 'Changed';

export interface EntitySnapshotDto {
  readonly key: string;
  readonly type: string;
  readonly source: EntityChangeType;
  readonly state: any;
}

export type EntitySnapshot =
  | {
      readonly key: string;
      readonly type: string;
      readonly source: EntityUpdateChangeType;
      readonly state: TcsEntityRecord;
    }
  | {
      readonly key: string;
      readonly type: string;
      readonly source: 'Removed';
    };

export interface EntitySnapshotCollection {
  readonly entities: EntitySnapshotDto[];
}

export class EntitiesReceived implements Action {
  public readonly type = ENTITIES_RECEIVED;
  constructor(public readonly entities: EntitySnapshot[], public readonly source?: string) {}
}

export class ResetEntities implements Action {
  public readonly type = RESET_ENTITIES;
}

export class RequestEntities implements Action {
  public readonly type = REQUEST_ENTITIES;
}

export type All = FetchEntities | EntitiesReceived | ResetEntities;
